/**
 * Created by r4zi4l on 17.12.2021
 */

const DraggableView = function (component, unitView) {
    this.unitView = unitView;
};

DraggableView.prototype.handleDragStart = function () {
    const spine = this.unitView.getAnimation();
    if (spine && spine.hasAnimation("idle_up")) {
        spine.setCompleteListener();
        spine.setAnimation(0, "idle_up", true);
    }
};

DraggableView.prototype.handleDragEnd = function (accepted) {
    if (accepted) {
        this.unitView.stopAllActions();
    }

    const spine = this.unitView.getAnimation();
    if (spine && spine.hasAnimation("idle_up")) {
        spine.setCompleteListener();

        const animations = UnitView.getUnitAnimations(this.unitView.unit);
        if (animations) {
            spine.setIdleSet(animations);
        } else {
            spine.setAnimation(0, "animation", true);
        }
    }
};

DraggableView.prototype.canBeAccepted = function (accepted) {
    this.unitView.stopAllActions();

    if (accepted) {
        this.acceptAction = this.unitView.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.ScaleTo(0.15, 1.15).easing(cc.easeInOut(2)),
            new cc.ScaleTo(0.20, 0.97).easing(cc.easeInOut(2)),
            new cc.ScaleTo(0.20, 1.15).easing(cc.easeInOut(2)),
            new cc.ScaleTo(0.25, 1).easing(cc.easeInOut(2)),
            new cc.DelayTime(0.3)
        )));
    } else {
        this.acceptAction = this.unitView.runAction(new cc.ScaleTo(0.1, 1));
    }
};

DraggableView.prototype.clearAnimations = function () {
    if (this.acceptAction && !this.acceptAction.isDone()) {
        this.unitView.stopAction(this.acceptAction);
        delete this.acceptAction;
    }
};

cleverapps.styles.DraggableView = {
    arrow: {
        x: { align: "center" },
        y: { align: "top", dy: 30 },
        delta: 10
    }
};